module.exports = __webpack_public_path__ + "static/DigikalaReactNativeCertificate-4ea43ee4d65e6c44da83e7a6a1ebaf37.jpg";